import TelegramBots from './TelegramBots.vue';

export const routes = [
  {
    path: 'telegram-bots',
    name: 'support_gateway_telegram_bots',
    meta: {
      permissions: ['administrator'],
    },
    component: TelegramBots,
  },
];

export default { routes };
